import { MODULOS } from "../../layouts/utils/modulos";
import { ConfigRoutes } from "../../shared/models/general/utils.interface";

interface AccesosActivosFijos {
    MANTENIMIENTO_ACTIVOS: ConfigRoutes
    GESTION_DOCUMENTARIA: ConfigRoutes
    ARTICULOS_INTANGIBLES: ConfigRoutes
    REPORTES: ConfigRoutes
    REPORTES_DEPRECIACION: ConfigRoutes
    REPORTES_INVENTARIO: ConfigRoutes
    REPORTES_FORMATO_7_1_DETALLE: ConfigRoutes
    REPORTES_FORMATO_7_4_LEASING: ConfigRoutes
    REPORTES_ASIENTO_DEPRECIACION: ConfigRoutes
    REPORTES_INVENTARIO_GESTION_DOCUMENTARIA: ConfigRoutes
}

interface ModuloActivosFijos {
    ID: number
    ACCESOS: AccesosActivosFijos
}

const pathModulo = '/activos-fijos/'
// Fuera de 'reportes/': el menu lateral marca activo por prefijo de ruta y resaltaria tambien "Activo fijo"
export const RUTA_REPORTES_GESTION_DOCUMENTARIA = 'reportes-gestion-documentaria'

export const MODULO_ACTIVOS_FIJOS: ModuloActivosFijos = {
    ID: MODULOS.ACTIVOS_FIJOS,
    ACCESOS: {
        MANTENIMIENTO_ACTIVOS: {
            TITLE: 'Activos fijos',
            ACCESS: 1,
            PATH_MODULE: pathModulo,
            DESCRI: 'Activos fijos',
            ROUTE: 'mantenimiento-activos'
        },
        GESTION_DOCUMENTARIA: {
            TITLE: 'Gestión documentaria',
            ACCESS: 3,
            PATH_MODULE: pathModulo,
            DESCRI: 'Gestión documentaria',
            ROUTE: 'gestion-documentaria'
        },
        ARTICULOS_INTANGIBLES: {
            TITLE: 'Artículos intangibles',
            ACCESS: 4,
            PATH_MODULE: pathModulo,
            DESCRI: 'Artículos intangibles',
            ROUTE: 'articulos-intangibles'
        },
        REPORTES: {
            TITLE: 'Reportes',
            ACCESS: 2,
            PATH_MODULE: pathModulo,
            DESCRI: 'Reportes',
            ROUTE: 'reportes'
        },
        REPORTES_DEPRECIACION: {
            TITLE: 'Depreciación de activos fijos',
            ACCESS: 2,
            PATH_MODULE: `${pathModulo}reportes/`,
            DESCRI: 'Reportes - Depreciación de activos fijo',
            ROUTE: 'depreciacion'
        },
        REPORTES_INVENTARIO: {
            TITLE: 'Inventario de activos fijos',
            ACCESS: 2,
            PATH_MODULE: `${pathModulo}reportes/`,
            DESCRI: 'Reportes - Inventario de activos fijos',
            ROUTE: 'inventario'
        },
        REPORTES_FORMATO_7_1_DETALLE: {
            TITLE: 'Formato 7.1: Detalle de activos fijos',
            ACCESS: 2,
            PATH_MODULE: `${pathModulo}reportes/`,
            DESCRI: 'Reportes -  Formato 7.1: Detalle de activos fijos',
            ROUTE: 'formato-7.1-detalle'
        },
        REPORTES_FORMATO_7_4_LEASING: {
            TITLE: 'Formato 7.4: Activos en leasing',
            ACCESS: 2,
            PATH_MODULE: `${pathModulo}reportes/`,
            DESCRI: 'Reportes -  Formato 7.4: Activos en leasing',
            ROUTE: 'formato-7.4-leasing'
        },
        REPORTES_ASIENTO_DEPRECIACION: {
            TITLE: 'Exportar asiento de depreciación',
            ACCESS: 2,
            PATH_MODULE: `${pathModulo}reportes/`,
            DESCRI: 'Reportes -  Exportar asiento de depreciación',
            ROUTE: 'asiento-depreciacion'
        },
        REPORTES_INVENTARIO_GESTION_DOCUMENTARIA: {
            TITLE: 'Inventario de Gestión Documentaria',
            ACCESS: 2,
            PATH_MODULE: `${pathModulo}${RUTA_REPORTES_GESTION_DOCUMENTARIA}/`,
            DESCRI: 'Reportes - Inventario de Gestión Documentaria',
            ROUTE: 'inventario-gestion-documentaria'
        }
    }
}

export const MODULO_ACTIVOS_FIJOS_BUSQUEDA = Object.entries(MODULO_ACTIVOS_FIJOS.ACCESOS).filter(item => item[1].DESCRI != null)
